import React from 'react';
import { useStore } from '../context/store';

export default function LoadMore() {
	const { state, dispatch } = useStore();

	const showLoadMore =
		state.series.length > state.currentPage * state.cardsPerPage;

	if (showLoadMore) {
		return (
			<div className="series-app__load-more">
				<button
					className="series-app__load-more-btn"
					onClick={() =>
						dispatch({
							type: 'setCurrentPage',
							payload: state.currentPage + 1,
						})
					}
				>
					Load More
				</button>
			</div>
		);
	}
	return '';
}
